module.exports = __webpack_public_path__ + "img/aball1_gs.b237f4c4.png";